import { render, staticRenderFns } from "./IncidentReport.html?vue&type=template&id=5c3e86b7&scoped=true&external"
import script from "./IncidentReport.js?vue&type=script&lang=js&external"
export * from "./IncidentReport.js?vue&type=script&lang=js&external"
import style0 from "./IncidentReport.scss?vue&type=style&index=0&id=5c3e86b7&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3e86b7",
  null
  
)

export default component.exports